import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import s from './ChangeIndicator.module.css';

const ChangeIndicator = ({ before, after }) => (
  <span className={s.container}>
    <span style={{ color: '#999999' }}>{before}</span>
    <Icon.ArrowRight height="20" width="20" />
    <span>{after}</span>
  </span>
);

ChangeIndicator.defaultProps = {
  before: undefined,
  after: undefined,
};

ChangeIndicator.propTypes = {
  before: PropTypes.string,
  after: PropTypes.string,
};

export default ChangeIndicator;
